import { ReactNode } from 'react';

import { IconsEnum } from '../../../../../../../../../assets/icons/types';
import { Translate } from '../../../../../../../../../helpers/Translate';
import {
  modelViewersKeys,
  words
} from '../../../../../../../../../locales/keys';
import { DisplaySettingsMenuItem } from '../DisplaySettingsMenuItem';

interface DisplaySettingsMainPanelProps {
  withDimensions: boolean;
  onToggleDimensions: () => void;
  withGridAxesHelper: boolean;
  onToggleGridAxes: () => void;
  isNeutralMode: boolean;
  onToggleNeutral: () => void;
  unitsLabel: ReactNode;
  meshLabel: ReactNode;
  aspectLabel: ReactNode;
  resolutionLabel: ReactNode;
  onOpenUnits: () => void;
  onOpenMesh: () => void;
  onOpenAspect: () => void;
  onOpenResolution: () => void;
}

const divider = (
  <hr className="border-gray-200 dark:border-gray-600 my-1 mx-3" />
);

function DisplaySettingsMainPanel({
  withDimensions,
  onToggleDimensions,
  withGridAxesHelper,
  onToggleGridAxes,
  isNeutralMode,
  onToggleNeutral,
  unitsLabel,
  meshLabel,
  aspectLabel,
  resolutionLabel,
  onOpenUnits,
  onOpenMesh,
  onOpenAspect,
  onOpenResolution
}: DisplaySettingsMainPanelProps) {
  return (
    <div className="flex flex-col w-full">
      <DisplaySettingsMenuItem
        icon={IconsEnum.DIMENSIONS_SOLID}
        label={<Translate id={words.showDimensions} />}
        toggle
        checked={withDimensions}
        onClick={onToggleDimensions}
      />
      <DisplaySettingsMenuItem
        icon={IconsEnum.UNITS_METRIC_CM_SOLID}
        label={<Translate id={words.changeUnits} />}
        currentValue={unitsLabel}
        withChevron
        onClick={onOpenUnits}
      />
      {divider}
      <DisplaySettingsMenuItem
        icon={IconsEnum.AXIS_SOLID}
        label={<Translate id={modelViewersKeys.showHelpers} />}
        toggle
        checked={withGridAxesHelper}
        onClick={onToggleGridAxes}
      />
      {divider}
      <DisplaySettingsMenuItem
        icon={IconsEnum.CONTRAST_SOLID}
        label={<Translate id={modelViewersKeys.enableNeutralMaterials} />}
        toggle
        checked={isNeutralMode}
        onClick={onToggleNeutral}
      />
      <DisplaySettingsMenuItem
        icon={IconsEnum.CUBE_TRANSPARENT_SOLID}
        label={<Translate id={modelViewersKeys.meshDisplay} />}
        currentValue={meshLabel}
        withChevron
        onClick={onOpenMesh}
      />
      {divider}
      <DisplaySettingsMenuItem
        icon={IconsEnum.CROP_SOLID}
        label={<Translate id={modelViewersKeys.aspectRatio} />}
        currentValue={aspectLabel}
        withChevron
        onClick={onOpenAspect}
      />
      <DisplaySettingsMenuItem
        icon={IconsEnum.PHOTOGRAPH_SOLID}
        label={<Translate id={modelViewersKeys.resolution} />}
        currentValue={resolutionLabel}
        withChevron
        onClick={onOpenResolution}
      />
    </div>
  );
}

export default DisplaySettingsMainPanel;
